import { queryKey } from '@features/operations/api/useAllPlans'
import { type Locutus, locutusModifyPlanApi } from 'api-validations/locutus'
import { useOrgCodeOrThrow } from 'shared-ui/active-operation'
import { queryClient, useApiClient, useMutation } from 'shared-ui/api-provider'

/**
 * Mutation for updating an existing plan for a field
 */
export const useUpdatePlan = () => {
  const orgCode = useOrgCodeOrThrow()
  const apiClient = useApiClient()

  return useMutation({
    mutationFn: ({ fieldId, id, ...body }: Omit<Locutus.Plan, 'orgCode' | 'lastModified'>) => {
      return apiClient.put(locutusModifyPlanApi.pathFor({ orgCode, fieldId, id }), { body })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKey, orgCode] })
      queryClient.invalidateQueries({ queryKey: [orgCode, 'field-plans'] })
    }
  })
}
